import React from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import { LoadingPlanSteps } from "../../CreateLoadingPlanPage";
import { ROUTES } from "../../../../consts/routes";
import "./Step5.scss";
import { partsService } from "../../../../services";

interface Step5Props {
  setCurrentStep: (step: LoadingPlanSteps) => void;
  currentPlanId: string | null;
}

const Step5: React.FC<Step5Props> = ({ setCurrentStep, currentPlanId }) => {
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate(ROUTES.home);
  };

  const handleViewLoadingPlan = () => {
    navigate(`${ROUTES.loadingPlans}/view/${currentPlanId}`);
  };

  const handleExportPdf = async () => {
    if (!currentPlanId) return;
    try {
      await partsService.exportPdf(+currentPlanId);
    } catch (error) {
      console.error('Failed to export PDF:', error);
    }
  };

  return (
    <Box className="step5">
      <Paper className="success-paper">
        {/* Success Icon */}
        <CheckCircleIcon color="success" className="success-icon" />

        {/* Title */}
        <Typography variant="h6" fontWeight={600} mb={1}>
          Plan Published Successfully!
        </Typography>

        {/* Subtitle */}
        <Typography variant="body2" color="text.secondary" mb={3}>
          Load plan <strong>{currentPlanId}</strong> is now available to field loaders.
        </Typography>

        {/* Buttons */}
        <Box className="buttons-row">
          <Button
            variant="contained"
            color="primary"
            className="button-no-transform"
            onClick={handleBackToDashboard}
          >
            BACK TO DASHBOARD
          </Button>
          <Button variant="outlined" onClick={handleViewLoadingPlan} className="button-no-transform">
            VIEW PLAN
          </Button>
          <Button variant="outlined" onClick={handleExportPdf} startIcon={<CheckCircleIcon />} className="button-no-transform">
            EXPORT PDF
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export { Step5 };
